import { cn, DecorativeIcon, type IconName } from "@netlify/ui";

export type CardTitleProps = {
  as?: React.ElementType | undefined;
  children?: React.ReactNode | undefined;
  className?: string | undefined;
  disabled?: boolean;
  iconName?: IconName | undefined;
  id?: string | undefined;
  inline?: boolean | undefined;
};

export const CardTitle = ({
  as: Component = "h1",
  children,
  className,
  disabled,
  iconName,
  inline,
  ...otherProps
}: CardTitleProps) => (
  <Component
    className={cn(
      "tw-flex",
      "tw-font-semibold",
      "tw-gap-2",
      "tw-justify-start",
      "tw-leading-tight",
      "tw-text-xl",
      "after:tw-content-none",
      inline ? "tw-flex-wrap" : "md:tw-justify-between",
      disabled && "tw-pointer-events-none tw-opacity-muted tw-grayscale",
      className,
    )}
    {...otherProps}
  >
    {iconName !== undefined && (
      <DecorativeIcon
        className="tw-mt-1"
        focusable="false"
        name={iconName}
        width={24}
      />
    )}
    {children}
  </Component>
);
